export default __webpack_public_path__ + "static/media/paysera.85902965.png";